<template>
    <main role="main" class="main login-partner"  v-bind:class="{ 'login-partner-mobile': isMobile }">
        <span class="mb-4" style="font-size: 25px;">Logga in Företag</span>
        <form @submit.prevent="login" class="mt-4" @keydown="form.errors.clear($event.target.name)">
            <input type="text" class="form-control" placeholder="E-post" name="email" v-model="form.email">
            <div v-if="form.errors.has('email')" class="invalid-feedback d-block text-left">
                {{ form.getError('email') }}
            </div>

            <input type="password" class="form-control mt-3" placeholder="Lösenord" name="password" v-model="form.password">
            <div v-if="form.errors.has('password')" class="invalid-feedback d-block text-left">
                {{ form.getError('password') }}
            </div>

            <div class="form-check float-left my-3">
                <label class="form-check-label text-light-w">
                    <input class="form-check-input" type="checkbox" value="option1">
                    Kom ihåg mig
                </label>
            </div>
            <span @click="showForgotPasswordModal" class="float-right my-3 text-red">Glömt lösenord?</span>
            <button type="submit" class="btn btn-danger d-block w-100" style="margin-top:4rem" v-if="form.processing">Loggar in...</button>
            <button type="submit" class="btn btn-danger d-block w-100" style="margin-top:4rem" v-else>Logga in</button>
        </form>
    </main>
</template>

<script>
    import Form from 'form-backend-validation';
    import AuthService from "../../services/auth.service";

    export default {
        data() {
            return {
                form: new Form({
                    email: null,
                    password: null,
                    remember: false,
                }),
                user: {},
                isMobile: false,
                submitted: false,
                errors: null,
            }
        },
        mounted() {
            // if(this.$route.name == 'login-partner-mobile'){
            //     this.isMobile = true;
            // }
        },
        methods: {
        login(){
            if (this.form.processing) {
                return;
            }

            this.form.processing = true;

            setTimeout(() => {
                AuthService.loginClient(this.form, () => {
                    $('#clientLoginModal').modal('hide');
                     this.$router.push({ name: 'client' });
                });
            }, 300);
            },
        showForgotPasswordModal(){
            $("#clientLoginModal").modal("hide");
            $("#forgotPasswordModal").modal("show");
        },
        }
    }
</script>
